// similar to TrussVerticalFillAlgorithm, but for legs.
export enum LegHorizontalLineAlgorithm {
  Sawtooth = 'sawtooth', //  \|\|\|\|
  Triangle = 'triangle', //  \/\/\/\/
}
